export const LOAD_TRANSLATION = 'LOAD_TRANSLATION';
export const SET_TRANSLATION_STATE = 'SET_TRANSLATION_STATE';
export const SET_TRANSLATION = 'SET_TRANSLATION';
export const RELOAD_TRANSLATION = 'RELOAD_TRANSLATION';
